'use client'

import type {
  DeeplinkOption,
  EventOption,
  WaitCallback,
} from 'airbridge-web-sdk-loader/build/airbridge_api'
import { createContext, useContext } from 'react'

export type OpenDeeplinkOption = DeeplinkOption & {
  type: 'click' | 'redirect'
}

type AirbridgeState = {
  isInitialized: boolean
  setUser: (userId: string) => void
  clearUser: () => void
  sendEvent: ({
    event,
    params,
    onSuccess,
  }: {
    event: string
    params: EventOption
    onSuccess?: WaitCallback
  }) => void
  openDeeplink: (openDeeplinkOption?: OpenDeeplinkOption) => void
}

export const AirbridgeContext = createContext<AirbridgeState | null>(null)

export const useAirbridgeContext = () => {
  const airbridge = useContext(AirbridgeContext)

  if (!airbridge) {
    throw new Error('Airbridge is not initialized')
  }

  return airbridge
}
